export const jakartownsOptions = {
  toolsEnabled: false,
  headerEnabled: false,
  minimapEnabled: false,
}
export const getAngleFromPoints = (lngLatA: { lat: number; lng: number }, lngLatB: { lat: number; lng: number }) => {
  const dy = lngLatA.lat - lngLatB.lat
  const dx = lngLatA.lng - lngLatB.lng
  const angle = Math.PI + Math.atan2(-dx, dy)
  return angle
}
